import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

const defaultLanguage = 'en-US';

// en-CA ships ONLY the keys whose wording differs (513 of 20,961). Everything else
// falls back to en-US, so a key added to en-US is already correct in en-CA without
// anyone copying it.
//
// This relies on i18next's resolution order. With load 'all',
// toResolveHierarchy('en-CA') builds ['en-CA', 'en', ...fallbackLng], but every code
// goes through isSupportedCode(): 'en' is not in supportedLngs and gets dropped. The
// effective order is ['en-CA', 'en-US'], and the http backend never requests
// /locales/en/*.json.
const supportedLanguages = [defaultLanguage, 'en-CA'];

i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: defaultLanguage,
        debug: false,
        supportedLngs: supportedLanguages,
        // Explicit because the per-key en-CA fallback above depends on it. 'all' is
        // already the i18next default; if an upgrade changes that default to
        // 'languageOnly', en-CA collapses to 'en', which is not supported, and the UI
        // starts rendering raw keys instead of the English text -- silently.
        load: 'all',
        detection: {
            // No cache: the detector writes the resolved language to localStorage by
            // default and reads it before navigator. Every current user already has
            // 'en-US' stored, so with caching on, a Canadian browser would stay on
            // en-US forever after this release. There is no language selector in this
            // app, so the browser is the only source of truth and there is no user
            // choice to persist.
            order: ['querystring', 'navigator'],
            lookupQuerystring: 'lng',
            caches: [],
        },
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
    });

export default i18n;
